const auth = {
  state: {
    token: "",
    product: "",
    mobile: "",
    faceActivity: 0,
    needHandIdCard: false,
    idCardRxImg: "",
    idCardName: "",
    idCardNum: "",
    address: "",
    familyName: "",
    birthday: "",
    sex: "",
    idCardGhImg: "",
    office: "",
    dateOfIssue: "",
    dateOfInvalid: "",
    dateOf: "",
    signatureImg: "",
    idCardBatchNo: ""
  },
  getters: {
    token: state => {
      return state.token;
    },
    product: state => {
      return state.product;
    },
    mobile: state => {
      return state.mobile;
    },
    faceActivity: state => {
      return state.faceActivity;
    },
    needHandIdCard: state => {
      return state.needHandIdCard;
    },
    needHandIdCard: state => {
      return state.needHandIdCard;
    },
    idCardRxImg: state => {
      return state.idCardRxImg;
    },
    idCardName: state => {
      return state.idCardName;
    },
    idCardNum: state => {
      return state.idCardNum;
    },
    address: state => {
      return state.address;
    },
    familyName: state => {
      return state.familyName;
    },
    birthday: state => {
      return state.birthday;
    },
    sex: state => {
      return state.sex;
    },
    idCardGhImg: state => {
      return state.idCardGhImg;
    },
    office: state => {
      return state.office;
    },
    dateOfIssue: state => {
      return state.dateOfIssue;
    },
    dateOfInvalid: state => {
      return state.dateOfInvalid;
    },
    dateOf: state => {
      return state.dateOf;
    },
    signatureImg: state => {
      return state.signatureImg;
    },
    idCardBatchNo: state => {
      return state.idCardBatchNo;
    },
  },
  mutations: {
    setToken: (state, val) => {
      state.token = val;
    },
    setProduct: (state, val) => {
      state.product = val;
    },
    setMobile: (state, val) => {
      state.mobile = val;
    },
    setFaceActivity: (state, val) => {
      state.faceActivity = val;
    },
    setNeedHandIdCard: (state, val) => {
      state.needHandIdCard = val;
    },
    setIdCardRxImg: (state, val) => {
      state.idCardRxImg = val;
    },
    setIdCardName: (state, val) => {
      state.idCardName = val;
    },
    setIdCardNum: (state, val) => {
      state.idCardNum = val;
    },
    setAddress: (state, val) => {
      state.address = val;
    },
    setFamilyName: (state, val) => {
      state.familyName = val;
    },
    setBirthday: (state, val) => {
      state.birthday = val;
    },
    setSex: (state, val) => {
      state.sex = val;
    },
    setIdCardGhImg: (state, val) => {
      state.idCardGhImg = val;
    },
    setOffice: (state, val) => {
      state.office = val;
    },
    setDateOfIssue: (state, val) => {
      state.dateOfIssue = val;
    },
    setDateOfInvalid: (state, val) => {
      state.dateOfInvalid = val;
    },
    setDateOf: (state, val) => {
      state.dateOf = val;
    },
    setSignatureImg: (state, val) => {
      state.signatureImg = val;
    },
    setIdCardBatchNo: (state, val) => {
      state.idCardBatchNo = val;
    },
  }
}

export default auth;